import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'
import { RegisterDto } from 'types/ApiTypes'

export const UsersApi = createApi({
  reducerPath: 'UsersAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Users'],
  endpoints: builder => ({
    addUsersAPI: builder.mutation({
      query: (body: RegisterDto) => ({
        url: `/api/Users/create`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Users'],
    }),
    getAllUsers: builder.query({
      query: (params: any) => ({
        url: `/api/Users`,
        method: 'GET',
        params,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Users'],
    }),
    getUserById: builder.query({
      query: id => ({
        url: `/api/Users/${id}`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['Users'],
    }),
    editUserById: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api/Users/edit/${id}`,
        body: data,
        method: 'PUT',
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Users'],
    }),
    deleteUsers: builder.mutation({
      query: id => ({
        url: `/api/Users/delete/${id}`,
        method: 'DELETE',
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Users'],
    }),
  }),
})

export const {
  useAddUsersAPIMutation,
  useGetAllUsersQuery,
  useGetUserByIdQuery,
  useEditUserByIdMutation,
  useDeleteUsersMutation,
} = UsersApi
